import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { PaymentMethod as PaymentMethodType } from "features/paymentMethods/types";
import type { OnboardingPaymentMethodProps } from "ui/molecules/PaymentMethod";
import type { OnboardingFormProps } from "ui/forms/Onboarding/types";
import type {
    WithRequestedChangeFileds,
    WithFieldsStatuses,
    WithFieldsComments
} from "features/onboarding/types";

export const enum FormField {
    Methods = 'methods'
};

export type PaymentMethod =
    & Pick<PaymentMethodType, 'tag'>
    & Pick<
        OnboardingPaymentMethodProps,
        | 'displayName'
        | 'imageUrl'
        | 'countriesAvailable'
    >;

export type OnboardingPaymentMethods =
    & WithFieldsStatuses
    & WithFieldsComments
    & WithRequestedChangeFileds
    & {
        readonly [FormField.Methods]: Array<string>;
    };

export type OnboardingPaymentMethodsBootstrapData = {
    readonly [FormField.Methods]: Array<PaymentMethod>;
};

export type OnboardingPaymentMethodsForm = Omit<
    BootstrapableForm<OnboardingPaymentMethods, OnboardingPaymentMethodsBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingPaymentMethods;
};

export type OnboardingPaymentMethodsProps =
    & OnboardingFormProps
    & OnboardingPaymentMethodsForm
    & ReturnType<typeof useForm<OnboardingPaymentMethods>>;
